import { BreakpointObserver } from '@angular/cdk/layout';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
  ViewChild,
  ElementRef,
  HostBinding,
} from '@angular/core';
import {
  GPU_MEDIA_QUERIES,
  GpuMediaQueryBreakpoints,
} from '@geneplanet/ngx-ui/src/lib/layout';

@Component({
  selector: 'app-container-popover',
  templateUrl: './container-popover.component.html',
  styleUrls: ['./container-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerPopoverComponent implements AfterViewInit {
  @Input() parentRef: ElementRef;
  @Input() arrowClass: string;
  @Input() popoverClass: string;

  @ViewChild('container') containerRef: ElementRef;
  @ViewChild('popover') popoverRef: ElementRef;

  @HostBinding('style.visibility') visibility = 'hidden';

  arrowLeftPosition = 0;
  popoverLeftPosition = 0;

  constructor(
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) {}

  @HostListener('window:resize')
  onResize() {
    this.updateDOM();
  }

  ngAfterViewInit() {
    setTimeout(() => this.updateDOM());
  }

  private updateDOM() {
    if (!this.parentRef || !this.containerRef || !this.popoverRef) {
      return;
    }

    const popoverMargin = this.breakpointObserver.isMatched(
      GPU_MEDIA_QUERIES[GpuMediaQueryBreakpoints.MD_UP]
    )
      ? 0
      : 16;
    this.popoverLeftPosition = popoverMargin;

    const parentRect = this.parentRef.nativeElement.getBoundingClientRect();
    const containerRect = this.containerRef.nativeElement.getBoundingClientRect();
    const popoverRect = this.popoverRef.nativeElement.getBoundingClientRect();

    this.arrowLeftPosition = parentRect.left + parentRect.width / 2;
    this.popoverLeftPosition = Math.max(
      this.arrowLeftPosition - popoverRect.width / 2,
      containerRect.left + popoverMargin
    );
    this.popoverLeftPosition = Math.min(
      this.popoverLeftPosition,
      containerRect.left +
        containerRect.width -
        popoverRect.width -
        popoverMargin
    );
    this.visibility = 'visible';

    this.cdr.markForCheck();
  }
}
